// Stops the payment form's Apply Coupon button submitting an empty code, which would only reload the
// page. Enter in the coupon field also lands here, as Apply is the form's first submit button.
// The server checks this too (BaseController.ValidateCoupon); this just saves the round trip.
export default function initCouponInput() {
  const applyButton = document.getElementById('btnValidate') as HTMLButtonElement;
  const couponInput = document.getElementById('CouponCode') as HTMLInputElement;
  const feedback = document.getElementById('CouponCode-feedback');

  if (applyButton == null || couponInput == null) return;

  const showError = (message: string) => {
    couponInput.classList.remove('is-valid');
    couponInput.classList.add('is-invalid');

    if (feedback != null) {
      feedback.textContent = message;
      feedback.classList.remove('field-validation-valid');
      feedback.classList.add('field-validation-error');
    }
  };

  const clearError = () => {
    couponInput.classList.remove('is-invalid');

    if (feedback != null) {
      feedback.textContent = '';
      feedback.classList.remove('field-validation-error');
      feedback.classList.add('field-validation-valid');
    }
  };

  applyButton.addEventListener('click', event => {
    if (couponInput.value.trim() === '') {
      // preventing the click stops the submit, so initSubmitButtons never adds its spinner
      event.preventDefault();
      showError('Enter a coupon code to apply.');
      couponInput.focus();
    }
  });

  couponInput.addEventListener('input', () => {
    if (couponInput.classList.contains('is-invalid')) {
      clearError();
    }
  });
}
